import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import RegistrationActiveCardV2 from './RegistrationActiveCardV2';

// TODO
// Error handle
// loading spinner
// possibly remove tools

class RegistrationActiveCardV2Show extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        loading:true,
      };
    }

    formatNumber(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    componentDidMount(){
        console.log("Loaded...")
    }

    render() {
        return (
            <Row style={{height:"100vh",paddingRight:"0",paddingLeft:"0"}}>
                <Col>
                    <RegistrationActiveCardV2></RegistrationActiveCardV2>
                </Col>
            </Row>
        );
    }
}

export default RegistrationActiveCardV2Show;